export { isArray, isNull, isNumber, isObject, isString, isUndefined } from "assertate";
